import React from 'react'

import { Button, ButtonSizes, ButtonVariants } from '@inno-ui/button'
import { MultiplyIcon } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import { CONTACTS_KEY_PREFIX } from '../../InnoscriptaContacts.constants'
import type { ContactGroup } from '../../InnoscriptaContacts.types'
import { ContactRow } from '../ContactRow'
import styles from './ContactsPopup.module.scss'

interface ContactsPopupProps {
  groups: ContactGroup[]
  onClose: () => void
  onChatClick: (authId: number) => void
}

export const ContactsPopup: React.FC<ContactsPopupProps> = ({
  groups,
  onClose,
  onChatClick
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: CONTACTS_KEY_PREFIX
  })

  return (
    <div
      role='dialog'
      aria-label={t('title')}
      data-testid='contacts-popup'
      className={styles.contactsPopup}
    >
      <div className={styles.header}>
        <h2 className={styles.title}>{t('title')}</h2>
        <Button
          type='button'
          icon={MultiplyIcon}
          label={t('actions.close')}
          isHiddenLabel
          size={ButtonSizes.S}
          variant={ButtonVariants.Ghost}
          data-testid='contacts-popup-close'
          onClick={onClose}
          aria-label={t('actions.close')}
        />
      </div>

      {groups.map(group => (
        <section key={group.titleKey} className={styles.group}>
          <h3 className={styles.groupTitle}>{t(group.titleKey)}</h3>

          {group.contacts.map(contact => (
            <ContactRow
              key={`${group.titleKey}-${contact.roleKey}`}
              contact={contact}
              onChatClick={onChatClick}
            />
          ))}
        </section>
      ))}
    </div>
  )
}
